import Button from '@components/button/button.view';
import IconButton from '@components/button/icon-button.view';

export default Button;

export { IconButton };
